import { useState } from 'react'
import {
  Fire,
  Heart,
  Laugh,
  OneHundred,
  Question,
  ThumbsUp,
} from '../../assets'
import * as Styled from './ReactionSelector.styles'
import { IconButton, useMediaQuery, useTheme } from '@mui/material'

type ReactionSelectorProps = {
  onReactionSelect: (reaction: string, isRemoving: boolean) => void
  isDisabled?: boolean
}

const ReactionSelector = ({
  onReactionSelect,
  isDisabled,
}: ReactionSelectorProps) => {
  const theme = useTheme()

  const isMobile = useMediaQuery(theme.breakpoints.down('tablet'))

  const reactions = [
    { name: 'Heart', icon: Heart },
    { name: 'Thumbs Up', icon: ThumbsUp },
    { name: 'Question', icon: Question },
    { name: 'Fire', icon: Fire },
    { name: 'One Hundred', icon: OneHundred },
    { name: 'Laugh', icon: Laugh },
  ]

  const [selectedReaction, setSelectedReaction] = useState<string | null>(null)

  const handleReactionClick = (reactionName: string) => {
    const isRemoving = selectedReaction === reactionName

    setSelectedReaction(isRemoving ? null : reactionName)

    // Call this outside the state update
    onReactionSelect(reactionName, isRemoving)
  }

  return (
    <>
      <Styled.ReactionStackContainer>
        {!selectedReaction && !isMobile && (
          <Styled.ReactionTitle>Leave a Reaction!</Styled.ReactionTitle>
        )}
        {reactions.map((reaction, index) => (
          <IconButton
            key={index}
            onClick={() => handleReactionClick(reaction.name)}
            disabled={isDisabled}
            style={{
              padding: 0,
              opacity: isDisabled ? 0.5 : 1,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
            }}
          >
            <Styled.ReactionIcon
              src={reaction.icon}
              alt={`${reaction.name} Reaction Icon`}
              style={{
                boxShadow:
                  selectedReaction === reaction.name
                    ? '0px 0px 12px 0px #002FAF33'
                    : 'none',
              }}
            />
          </IconButton>
        ))}
      </Styled.ReactionStackContainer>
    </>
  )
}

export default ReactionSelector
